import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@components/auth/AuthContext';

type AuthRouter = {
  redirectToLogin?: boolean;
  requiredAuthState: 'loggedOut' | 'loggedIn';
  redirectURL: string;
};
export const AuthRouter: React.FC<AuthRouter> = ({
  requiredAuthState,
  redirectURL,
}) => {
  const authState = useAuthContext();

  const doAuthStatesMatch = authState.type === requiredAuthState;

  return doAuthStatesMatch ? <Outlet /> : <Navigate to={redirectURL} />;
};
